'use strict';

var _ = require('lodash');

var handlers = {
    NICK: function NICK(command) {
        var time;

        // Check if we have a server-time
        time = command.getServerTime();

        this.emit('nick', {
            nick: command.nick,
            ident: command.ident,
            hostname: command.hostname,
            new_nick: command.params[0],
            time: time
        });
    },

    ACCOUNT: function ACCOUNT(command) {
        var time;

        // Check if we have a server-time
        time = command.getServerTime();

        var account = command.params[0] === '*' ? false : command.params[0];

        this.emit('account', {
            nick: command.nick,
            ident: command.ident,
            hostname: command.hostname,
            account: account,
            time: time
        });
    },

    // If the chghost CAP is enabled and 'enable_chghost' option is true
    CHGHOST: function CHGHOST(command) {
        var time;

        // Check if we have a server-time
        time = command.getServerTime();

        this.emit('user updated', {
            nick: command.nick,
            ident: command.ident,
            hostname: command.hostname,
            new_ident: command.params[0],
            new_host: command.params[1],
            time: time
        });
    },

    AWAY: function AWAY(command) {
        var time;

        // Check if we have a server-time
        time = command.getServerTime();
        var message = command.params[command.params.length - 1];
        if (message === '') {
            // back
            this.emit('back', {
                nick: command.nick,
                message: '',
                time: time
            });
        } else {
            this.emit('away', {
                nick: command.nick,
                message: message,
                time: time
            });
        }
    },

    RPL_NOWAWAY: function RPL_NOWAWAY(command) {
        var time;

        // Check if we have a server-time
        time = command.getServerTime();

        this.emit('away', {
            nick: command.nick,
            message: command.params[command.params.length - 1],
            time: time
        });
    },

    RPL_UNAWAY: function RPL_UNAWAY(command) {
        var time;

        // Check if we have a server-time
        time = command.getServerTime();

        this.emit('back', {
            nick: command.nick,
            message: command.params[command.params.length - 1] || '', // example: "<nick> is now back."
            time: time
        });
    },

    RPL_ISON: function RPL_ISON(command) {
        this.emit('users online', {
            nicks: (command.params[command.params.length - 1] || '').split(' ')
        });
    },

    ERR_NICKNAMEINUSE: function ERR_NICKNAMEINUSE(command) {
        this.emit('nick in use', {
            nick: command.params[1],
            reason: command.params[command.params.length - 1]
        });
    },

    ERR_ERRONEUSNICKNAME: function ERR_ERRONEUSNICKNAME(command) {
        this.emit('nick invalid', {
            nick: command.params[1],
            reason: command.params[command.params.length - 1]
        });
    },

    RPL_ENDOFWHOIS: function RPL_ENDOFWHOIS(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);

        if (!cache.nick) {
            cache.nick = command.params[1];
            cache.error = 'not_found';
        }

        this.emit('whois', cache);
        cache.destroy();
    },

    RPL_AWAY: function RPL_AWAY(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.away = command.params[command.params.length - 1] || 'is away';
    },

    RPL_WHOISUSER: function RPL_WHOISUSER(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.nick = command.params[1];
        cache.user = command.params[2];
        cache.host = command.params[3];
        cache.real_name = command.params[5];
    },

    RPL_WHOISHELPOP: function RPL_WHOISHELPOP(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.helpop = command.params[command.params.length - 1];
    },

    RPL_WHOISBOT: function RPL_WHOISBOT(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.bot = command.params[command.params.length - 1];
    },

    RPL_WHOISSERVER: function RPL_WHOISSERVER(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.server = command.params[2];
        cache.server_info = command.params[command.params.length - 1];
    },

    RPL_WHOISOPERATOR: function RPL_WHOISOPERATOR(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.operator = command.params[command.params.length - 1];
    },

    RPL_WHOISCHANNELS: function RPL_WHOISCHANNELS(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        if (cache.channels) {
            cache.channels += ' ' + command.params[command.params.length - 1];
        } else {
            cache.channels = command.params[command.params.length - 1];
        }
    },

    RPL_WHOISMODES: function RPL_WHOISMODES(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.modes = command.params[command.params.length - 1];
    },

    RPL_WHOISIDLE: function RPL_WHOISIDLE(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.idle = command.params[2];
        if (command.params[3]) {
            cache.logon = command.params[3];
        }
    },

    RPL_WHOISREGNICK: function RPL_WHOISREGNICK(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.registered_nick = command.params[command.params.length - 1];
    },

    RPL_WHOISHOST: function RPL_WHOISHOST(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);

        var last_param = command.params[command.params.length - 1];
        // <source> 378 <target> <nick> :is connecting from <user>@<host> <ip>
        var match = last_param.match(/.*@([^ ]+) ([^ ]+).*$/); // https://regex101.com/r/AQz7RE/2

        if (!match) {
            return;
        }

        cache.actualip = match[2];
        cache.actualhost = match[1];
    },

    RPL_WHOISSECURE: function RPL_WHOISSECURE(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.secure = true;
    },

    RPL_WHOISACCOUNT: function RPL_WHOISACCOUNT(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.account = command.params[2];
    },

    RPL_WHOISSPECIAL: function RPL_WHOISSPECIAL(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);
        cache.special = command.params[command.params.length - 1];
    },

    RPL_WHOISACTUALLY: function RPL_WHOISACTUALLY(command) {
        var cache_key = command.params[1].toLowerCase();
        var cache = this.cache('whois.' + cache_key);

        // <source> 338 <target> <nick> <user>@<host> <ip> :Actual user@host, Actual IP
        var user_host = command.params[command.params.length - 3];
        var host = user_host.substring(user_host.indexOf("@") + 1);
        var ip = command.params[command.params.length - 2];

        cache.actualip = ip;
        cache.actualhost = host;
    },

    RPL_WHOWASUSER: function RPL_WHOWASUSER(command) {
        this.emit('whowas', {
            nick: command.params[1],
            ident: command.params[2],
            host: command.params[3],
            real_name: command.params[command.params.length - 1]
        });
    },

    RPL_ENDOFWHOWAS: function RPL_ENDOFWHOWAS() {
        // noop
    },

    ERR_WASNOSUCHNICK: function ERR_WASNOSUCHNICK(command) {
        this.emit('whowas', {
            nick: command.params[1],
            error: 'no_such_nick'
        });
    },

    RPL_UMODEIS: function RPL_UMODEIS(command) {
        // this.connection.umodes = the modes
        // TODO: this
    },

    RPL_HOSTCLOACKING: function RPL_HOSTCLOACKING(command) {
        this.emit('displayed host', {
            nick: command.params[0],
            host: command.params[1]
        });
    }
};

module.exports = function AddCommandHandlers(command_controller) {
    _.each(handlers, function (handler, handler_command) {
        command_controller.addHandler(handler_command, handler);
    });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/build/commands/handlers/user.js
// module id = WEr6
// module chunks = 0